var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreWix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FBBD71;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wix-com-website-logo-1",
    transform: "translate(9559.393 482.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    className: "st0",
    d: "M-9503.53-448.15c-1.56,0.78-2.24,2.24-2.24,6.2c0.59-0.54,1.28-0.97,2.03-1.25 c0.73-0.28,1.41-0.65,2.03-1.12c1.36-1.02,1.56-2.24,1.56-4.38C-9500.16-448.7-9502.3-448.83-9503.53-448.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M-9513.09-447.24c-0.87,0.81-1.46,1.88-1.69,3.05l-4.38,16.79l-3.6-13.74c-0.35-1.63-1.04-3.17-2.03-4.51 c-1.25-1.59-3.86-1.69-4.17-1.69c-0.24,0-2.82,0.1-4.17,1.69c-0.99,1.34-1.68,2.88-2.03,4.51l-3.39,13.74l-4.38-16.79 c-0.26-1.16-0.85-2.22-1.69-3.05c-2.14-1.93-5.29-1.46-5.29-1.46l8.34,31.41c0,0,2.71,0.23,4.07-0.44c1.8-0.91,2.71-1.56,3.73-5.87 c1.02-3.83,3.73-14.99,3.94-15.77c0.1-0.34,0.34-1.36,1.02-1.36c0.68,0,0.91,0.91,1.02,1.36c0.24,0.78,2.92,11.94,3.94,15.77 c1.12,4.28,1.9,4.95,3.73,5.87c1.36,0.68,4.07,0.44,4.07,0.44l8.29-31.41C-9507.8-448.7-9510.96-449.14-9513.09-447.24 L-9513.09-447.24z M-9500.16-443.64c-0.47,0.58-1.05,1.08-1.69,1.46c-0.78,0.44-1.46,0.68-2.24,1.12 c-1.36,0.68-1.69,1.36-1.69,2.37v21.3c0,0,2.14,0.23,3.49-0.44c1.8-0.91,2.14-1.8,2.14-5.63L-9500.16-443.64L-9500.16-443.64z  M-9479.44-432.93l10.58-15.67c0,0-4.38-0.78-6.65,1.25c-1.12,1.07-2.1,2.28-2.92,3.59l-3.83,5.63c-0.23,0.34-0.44,0.57-0.78,0.57 c-0.34-0.05-0.63-0.26-0.78-0.57l-3.83-5.63c-0.89-1.27-1.86-2.47-2.92-3.6c-2.25-2.03-6.65-1.25-6.65-1.25l10.25,15.64 l-10.48,15.64c0,0,4.61,0.57,6.88-1.46c1.07-1.01,2.02-2.15,2.82-3.39l3.83-5.63c0.23-0.34,0.44-0.57,0.78-0.57 c0.34,0.05,0.63,0.26,0.78,0.57l3.83,5.63c0.83,1.21,1.78,2.35,2.82,3.39c2.24,2.03,6.75,1.46,6.75,1.46L-9479.44-432.93z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreWix);
export default __webpack_public_path__ + "static/media/store-wix.1ccacd830ae356e563e97790e1051efd.svg";
export { ForwardRef as ReactComponent };